import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SeekForward30Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SeekForward30",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.36 15.5c-.21-.13-.45-.21-.69-.21-.72-.01-1.31.57-1.32 1.29-.05 1.04-.25 2.07-.59 3.06-2.02 5.92-8.46 9.09-14.38 7.07a11.2 11.2 0 0 1-6.71-6.05c-.19-.42-.35-.84-.49-1.28-1.59-5.13.61-10.67 5.29-13.32l.19-.1c3.51-1.9 7.76-1.79 11.17.28l.55.34-2.68 1.43c-.18.1-.28.29-.26.5.01.2.15.38.34.44l6.17 2.09c.14.04.28.03.41-.04a.47.47 0 0 0 .24-.31l1.68-6.29c.05-.2-.03-.41-.19-.53a.485.485 0 0 0-.55-.05L24.9 5.23A13.95 13.95 0 0 0 9.42 3.67l-.6.32a13.99 13.99 0 0 0-5.96 16.84c.11.3.21.62.36.9 1.58 3.56 4.6 6.28 8.29 7.5 1.23.42 2.51.66 3.8.73 7.71.39 14.28-5.55 14.67-13.26 0-.48-.23-.94-.64-1.2Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.37 18.75c-.21.12-.43.19-.68.19-.23 0-.43-.05-.62-.12-.19-.08-.38-.21-.57-.38-.18-.17-.36-.39-.54-.67l-1.11.7c.37.63.77 1.08 1.21 1.33.43.26.95.4 1.54.4.53 0 1.01-.12 1.45-.36q.645-.36 1.02-.96c.375-.6.38-.87.38-1.39a2.4 2.4 0 0 0-.72-1.75c-.22-.23-.48-.41-.78-.53-.26-.11-.55-.17-.84-.18l2.16-2.35-.27-.55h-4.66v1.3l2.71.02-1.97 2.17.37.96c.18-.07.34-.12.5-.18.15-.05.29-.09.43-.11s.26-.04.39-.04c.27 0 .5.06.7.15.19.1.34.26.44.44.09.19.15.42.15.69s-.07.51-.19.73c-.12.21-.29.38-.5.49M21.09 12.52c-.46-.33-1.01-.49-1.66-.49s-1.19.16-1.65.49q-.69.495-1.05 1.41c-.36.915-.37 1.34-.37 2.18s.12 1.57.37 2.18q.375.915 1.05 1.41c.46.33 1.01.49 1.65.49s1.19-.16 1.66-.49c.46-.33.81-.8 1.06-1.41s.37-1.34.37-2.18-.12-1.57-.37-2.18-.6-1.08-1.06-1.41m-.42 5.65c-.29.49-.7.73-1.23.73s-.94-.24-1.23-.73-.44-1.17-.44-2.06.15-1.58.44-2.08c.29-.49.7-.74 1.23-.74s.94.25 1.23.74.44 1.18.44 2.08-.15 1.57-.44 2.06"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.71 11.29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l3.76-3.76-3.76-3.76a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l4.57 4.57c.45.45.45 1.17 0 1.62l-4.57 4.57c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 31.86c-7.56 0-13.71-6.15-13.71-13.71S8.01 4.43 15.57 4.43h5.71a1.14 1.14 0 1 1 0 2.28h-5.71c-6.3 0-11.43 5.13-11.43 11.43s5.13 11.43 11.43 11.43S27 24.44 27 18.14c0-2.94-1.12-5.74-3.14-7.87-.44-.46-.42-1.18.04-1.62a1.15 1.15 0 0 1 1.62.04c2.43 2.56 3.77 5.92 3.77 9.45 0 7.56-6.15 13.71-13.71 13.71Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 22.64v-2.37h.04c.78.56 1.56.84 2.38.84.89 0 1.4-.5 1.4-1.13 0-.57-.49-1.09-1.54-1.09h-1.1v-.09l1.42-2.61H8.8v-2.12h5.8v.13l-1.77 3.35c1.23.35 1.98 1.4 1.98 2.64 0 1.84-1.42 3.07-3.62 3.07-.97 0-1.86-.25-2.47-.62ZM15.84 18.6c0-2.76 1.53-4.66 3.74-4.66s3.83 1.9 3.83 4.66-1.57 4.66-3.83 4.66-3.74-1.9-3.74-4.66m5.2 0c0-1.75-.53-2.73-1.46-2.73-.88 0-1.37.98-1.37 2.73s.49 2.64 1.37 2.64c.93 0 1.46-.95 1.46-2.64"
      })]
    })
  }));
};